import { put, call } from "redux-saga/effects";
import {    
    UPDATE_EVENT_COMPLETED,UPDATE_EVENT_FAILED,
    GET_EVENT_COMPLETED,GET_EVENT_FAILED,
    SAVE_EVENT_COMPLETED,SAVE_EVENT_FAILED} from "../actions/UpEvent";

import { UpEventAPI } from "../../utils/api/UpEventAPI";
export function* comingEvents(request: any) {
    
   
    try {
        
         const result=yield call(UpEventAPI.getupevent, request.input);
      
        yield put({ 
            type: SAVE_EVENT_COMPLETED,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_EVENT_FAILED, payload: e.message });
    }
}

export function* getcomingEvents(request: any) {
    
   
    try {
        
         const result=yield call(UpEventAPI.getcomingupevent, request.input);
      
        yield put({ 
            type: GET_EVENT_COMPLETED,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: GET_EVENT_FAILED, payload: e.message });
    }
}
export function* updatecomingEvents(request: any) {
  //  alert("sagas UPDATEeventData");

   
    try {
        
         const result=yield call(UpEventAPI.updateupcomingevent, request.input);
      
        yield put({ 
            type: UPDATE_EVENT_COMPLETED,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_EVENT_FAILED, payload: e.message });
    }
}
